/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-navigation-arrow-up': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M10 2.5L3.75 8.75l.881.881 4.744-4.737V18.75h1.25V4.894l4.744 4.737.881-.881z"/>'
  }
})
